<template>
    <div class="tickBox" >
        <el-row>
            <el-col :span='24' class="tickMid">
                <el-col :span="12" class="mma">
                    银票极速贴-业务统计
                </el-col>
                <el-col :span="12" class="rigrig">
                    <el-button type="primary" plain class="butsTwo" @click="handleExcel">全部导出</el-button>
                    <!-- <el-button type="primary" class="butsTwo" @click="handleSearch">勾选导出</el-button> -->
                </el-col>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24" class="formBox" >
                    <span class="spanfont">
                            邀请码
                    </span>
                    <div class="radioBox">
                        <el-input v-model="codeValue" placeholder="请输入邀请码"></el-input>
                    </div>
                    <span class="spanfont">
                            注册手机号
                    </span>
                    <div class="radioBox">
                        <el-input v-model="phoneValue" placeholder="请输入手机号"></el-input>
                    </div>
                    <span class="spanfont">
                            公司名称
                    </span>
                    <div class="radioBox">
                        <el-input v-model="comValue" placeholder="请输入公司名称"></el-input>
                    </div>
                    <span class="spanfont">
                            贴现时间
                    </span>
                    <div class="radioBox">
                            <el-date-picker
                                v-model="value1"
                                type="daterange"
                                value-format='yyyy-MM-dd'
                                :clearable='false'
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                            </el-date-picker>
                    </div>
                    <div class="radioBox">
                        <el-button type="primary" plain class="butsOne" @click="handleReset">重置</el-button>
                        <el-button type="primary" class="butsTwo" @click="handleSearch">查询</el-button>
                    </div>
            </el-col>
            <el-col :span="24" v-loading="loading" class="tabBox">
                <el-table
                    :data="tableData"
                    border
                    stripe
                    style="width: 100%"
                >
                    <!-- <el-table-column
                        type="selection"
                        width="55">
                    </el-table-column> -->
                    <el-table-column
                        prop="xh"
                        label="序号"
                        >
                    </el-table-column>
                    <el-table-column
                        prop="partner"
                        label="邀请码(推荐人)"
                        >
                    </el-table-column>
                    <el-table-column
                        prop="Bmobile"
                        label="注册手机号(用户)"
                        >
                    </el-table-column>
                    <el-table-column
                        prop="Bcompany_name"
                        label="公司名称"
                        >
                    </el-table-column>
                    <el-table-column
                        prop="Bbill_code"
                        label="票据号码"
                        >
                    </el-table-column>
                    <el-table-column
                        prop="bill_amount"
                        label="票面金额"
                        >
                    </el-table-column>
                    <el-table-column
                        prop="endtime"
                        label="到期日"
                        >
                    </el-table-column>
                    <el-table-column
                        prop="transactiontime"
                        label="贴现时间"
                        >
                    </el-table-column>
                    <el-table-column
                        prop="days"
                        label="计息天数"
                        >
                    </el-table-column>
                    <el-table-column
                        prop="bank"
                        label="贴现银行"
                        >
                    </el-table-column>
                    <!-- <el-table-column
                        label="备注"
                        width="80">
                        <template slot-scope="scope">
                            <el-button @click="handleClick(scope.row)" type="text" size="small">详情</el-button>
                        </template>
                    </el-table-column> -->
                </el-table>
            </el-col>
            <el-col :span="24" class="pageBox">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :page-size='10'
                    @current-change='handleChangePage'
                    :total=total>
                </el-pagination>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    data(){
        return{
            loading:true,
            codeValue:'',
            phoneValue:'',
            comValue:'',
            value1:[],
            input:'',
            tableData: [],
            value:'',
            total:100,
            pageSize:1
        }
    },
    mounted(){
        this.handleAjax()
    },
    methods: {
        handleExcel(){
            let bizContent={}
            bizContent.merchant=''
            bizContent.partner=this.codeValue
            bizContent.mobile=this.phoneValue
            bizContent.companyname=this.comValue
            bizContent.pageNum=this.pageSize
            bizContent.limit="10"
            if(this.value1.length!=0){
                bizContent.begindate=this.value1[0]
                bizContent.enddate=this.value1[1]
            }else{
                bizContent.begindate=''
                bizContent.enddate=''
            }
            this.ajax.post('/merchant/allebillExport',{bizContent})
                    .then(
                        res=>{
                            var blob = new Blob([res.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'});
                            var contentDisposition = res.headers['content-disposition'];  //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
                            console.log(contentDisposition)
                            var patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
                            var result = patt.exec(contentDisposition);
                            var filename = '业务统计.xls';
                            var downloadElement = document.createElement('a');
                            var href = window.URL.createObjectURL(blob); //创建下载的链接
                            downloadElement.style.display = 'none';
                            downloadElement.href = href;
                            downloadElement.download =filename ; //下载后文件名
                            document.body.appendChild(downloadElement);
                            downloadElement.click(); //点击下载
                            document.body.removeChild(downloadElement); //下载完成移除元素
                            window.URL.revokeObjectURL(href);
                        }
            )
        },
        handleAjax(){
            this.loading=true
            let bizContent={}
            bizContent.merchant=''
            bizContent.partner=this.codeValue
            bizContent.mobile=this.phoneValue
            bizContent.companyname=this.comValue
            bizContent.pageNum=this.pageSize
            bizContent.limit="10"
            if(this.value1.length!=0){
                bizContent.begindate=this.value1[0]
                bizContent.enddate=this.value1[1]
            }else{
                bizContent.begindate=''
                bizContent.enddate=''
            }
            this.ajax.post('/merchant/allebill',{bizContent})
                    .then(
                        res=>{
                            if(res.data.status=='0000'){
                                console.log('123')
                                let arr = res.data.data.data
                                arr.map((it,index)=>{
                                    it.xh=index+1
                                })
                                this.tableData=arr
                                this.total=res.data.data.total
                                this.loading=false
                            }else{
                                this.$message(res.data.data.message);
                            }
                        }
            )
        },
        handleChangePage(val){
            this.pageSize=val
            this.handleAjax()
        },
        handleClick(row) {
            this.$router.push({
                path:'/mentMonInfor',
                query:{
                    id:row.Buid,
                    code:row.Borganization_code
                }
            })
        },
        handleReset(){
            this.codeValue=''
            this.phoneValue=''
            this.comValue=''
            this.value1=[]
        },
        handleSearch(){
            this.handleAjax()
        }
    }
}
</script>

<style  scoped>
.tickBox{
    margin-left: 20px;
}
.tickMid{
    margin-top: 10px;
    width: 100%;
    background: #fff;
    height: 55px;
    line-height: 50px;
    text-align: left;
    padding: 10px 15px;
    /* box-shadow: 2px 2px 2px #eee; */
}
.mma{
    font-size: 24px;
    padding-left: 10px;
}
.rigrig{
    text-align: right;
}
.formBox{
    padding: 20px 5px 20px 15px;
    background: #fff;
    /* border: 2px solid #eee;
    box-shadow: 2px 2px 4px #eee; */
    /* margin: 10px 0; */
}
.alls{
    margin-top: 20px;
}
.radioBox{
    height: 40px;
    line-height: 40px;
    margin-right: 10px;
    display: inline-block;
    margin-bottom: 10px;
}
.radioBox>>>.el-input__inner{
    width: 224px;
}
.selBox{
    margin-right: 20px;
}
.butsOne{
    width: 74px;
    height: 30px;
    padding: 0;
}
.butsTwo{
    width: 74px;
    height: 30px;
    padding: 0;
    margin-right: 20px;
}
.spanfont{
    height: 40px;
    width: 70px;
    display: inline-block;
    text-align: right;
    line-height: 40px;
    margin-right: 5px;
    margin-left: 5px;
    color: #333333;
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 10px;
}
.pickBox>.el-input__inner{
    width: 305px;
}
.el-input__inner{
    width: 455px;
}
.tabBox{
    /* min-height: 720px; */
    background: #fff;
    padding: 0 20px;
}
/* .tabBox>>>.el-table__empty-text{
    min-height: 360px;
    line-height: 360px;
} */
.tabBox>>>.el-table__body-wrapper{
    min-height: 710px;
    overflow-y: auto;
}
.tabBox>>>.el-table__body-wrapper::-webkit-scrollbar {
    width: 5px;
    height: 5px;
}
.tabBox>>>.el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #ddd;
    border-radius: 3px;
}
.pageBox{
    text-align: center;
    margin: 20px 0;
}
</style>


// WEBPACK FOOTER //
// src/PAGE/bankAcceptance/static.vue